import { render, staticRenderFns } from "./commune-form.vue?vue&type=template&id=1a584cc6&"
import script from "./commune-form.vue?vue&type=script&lang=js&"
export * from "./commune-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports